<template>
  <helper-layout :loaded="mx_loaded">
    <v-layout column>
      <v-flex>
        <!-- 步骤1 -->
        <v-card v-show="!showThirdStep">
          <!-- 1.下载模板: -->
          <v-layout column>
            <v-flex>
              <div class="card-title">
                {{ $t("Views.Customer.downloadTemplate") }}
              </div>
            </v-flex>
            <v-flex>
              <p style="margin:10px 10px 10px 30px;">
                <!-- 导入规则说明： -->
                {{ $t("Views.Customer.importRuleDesc") }}
              </p>
              <p style="margin:10px 10px 10px 30px;">
                {{ $t("Views.Sales.exportTips") }}
              </p>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs2 align-self-center>
              <v-btn color="success" style="margin:10px 10px 20px 30px;">
                <a
                  class="download-button"
                  :href="getDownUrl"
                  download="ImportShopAuthorizationTemplate.xlsx"
                >
                  <!-- 下载Excel模板 -->
                  {{ $t("Views.Customer.downloadExcel") }}
                </a>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <!-- 步骤2 -->
        <v-card v-show="!showThirdStep" class="mt-20">
          <!-- 2.上传文件: -->
          <v-layout column>
            <v-flex>
              <div class="card-title">
                2.{{ $t("Views.Customer.uploadFile") }}
              </div>
            </v-flex>
            <v-flex>
              <p style="margin:10px 10px 10px 30px;">
                {{ getSeconStepTip }}
              </p>
            </v-flex>
            <v-layout class="fix-margin">
              <v-flex align-self-center>
                <!-- accept="image/*" -->
                <input
                  id="uploadButton"
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  value="选择图片"
                  style="display: none;"
                  @change="onSelectExcel"
                >
                <v-btn
                  style="margin: 10px 10px 20px 0px; "
                  color="success"
                  @click="onUploadClick"
                >
                  <!-- 点击上传 -->
                  {{ $t("Views.Customer.uploadClick") }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>

        <!-- 步骤3 -->
        <v-layout v-show="showThirdStep" column>
          <v-card>

            <v-layout column>
              <v-flex>
                <div class="card-title">
                  3.{{ $t("Views.Customer.sureImport") }}
                </div>
              </v-flex>
              <v-flex>
                <p style="margin:10px 10px 10px 30px;color:#4CAF50 ">
                  {{ total }}
                </p>
              </v-flex>
              <v-flex
                v-show="validateExcelData && validateExcelData.invalidedRows > 0 "
              >
                <material-table
                  class="fix-table"
                  :headers="headers"
                  :items="showItems"
                  :paginate="paginateConfig"
                  @pageChange="handlePageChange"
                />
              </v-flex>

            </v-layout>
          </v-card>
          <v-flex style="text-align:center;margin-top:20px;">
            <v-spacer />
            <v-btn @click="onPreviousStep">
              <!-- 上一步 -->
              {{ $t("Views.Customer.lastStep") }}
            </v-btn>
            <!--正确数据为0条时，则不显示“确认导入”按钮-->
            <v-btn v-if="validateExcelData.validatedRows!==0" color="success" @click="onSubmitClick">
              <!-- 确认导入 -->
              {{ $t("Views.Customer.importSure") }}
            </v-btn>
            <v-spacer />
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- 正在加载数据loading -->
      <div v-if="showLoading" class="showLoading-wrap">
        <v-layout column style="background-color:#5cb860">
          <v-flex>
            <h3 style="text-align:center;color:white;padding:10px;">
              {{ tip }}
            </h3>
          </v-flex>
          <v-flex style="margin:0 10px 0 10px;">
            <v-progress-linear
              :value="progress"
              indeterminate
              color="white"
              height="10"
            />
          </v-flex>
        </v-layout>
      </div>
    </v-layout>
  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      headers: [
        {
          text: $t('Views.Customer.lines'),
          value: 'rowIndexStr',
          sortable: false
        },
        {
          text: $t('Views.Customer.resonErr'),
          value: 'errorMessage',
          sortable: true
        }
      ],
      showItems: [],
      progress: 0,
      showLoading: false,
      isValidate: true,
      file: null,
      items: [],
      showThirdStep: false,
      config: {
        label: 'name',
        value: 'id',
        children: 'items'
      }
    }
  },
  computed: {
    ...mapState('sales', ['validateExcelData']),
    total() {
      return this.$t('Views.Goods.errorTips', {
        '0': this.validateExcelData.templateRows,
        '1': this.validateExcelData.validatedRows,
        '2': this.validateExcelData.invalidedRows
      })
    },

    getSeconStepTip() {
      if (this.$i18n.locale === 'ja') {
        return this.$t('Views.Goods.exportInfoDetails2')
      } else {
        return this.$t('Views.Goods.exportInfoDetails2')
      }
    },

    tip() {
      return this.isValidate
        ? this.$t('Views.Goods.validateDataPending')
        : this.$t('Views.Goods.uploadDataPending')
    },

    /** 模板地址 */
    getDownUrl() {
      const locale = this.$i18n.locale
      switch (locale) {
        case 'zh-Hans':
          return '/Templates/zh-Hans/ImportShopAuthorizationTemplate.xlsx'
        case 'ja':
          return '/Templates/ja-JP/ImportShopAuthorizationTemplate.xlsx'
        default:
          return '/Templates/zh-Hans/ImportShopAuthorizationTemplate.xlsx'
      }
    }
  },
  mounted() {
    this.mx_loaded_fn()
  },
  created() {

  },
  methods: {
    ...mapActions('sales', [
      'handleValidateExcel',
      'handleImportExcel'
    ]),
    handlePageChange(page) {
      this.paginateConfig.page = page
      this.showItems = this.getItemsByPage()
    },
    getItemsByPage() {
      const page = this.paginateConfig.page
      const pageSize = this.paginateConfig.pageSize
      if (this.validateExcelData.invalidedMessages.length > 0) {
        return this.validateExcelData.invalidedMessages.slice(
          (page - 1) * pageSize,
          page * pageSize
        )
      } else {
        return []
      }
    },
    /** 点击了上一步 */
    onPreviousStep() {
      this.showThirdStep = false
    },
    /** 点击确认导入 */
    onSubmitClick() {
      if (this.file) {
        this.onConfirmUpload()
      }
    },
    /** 点击了上传文件 */
    onUploadClick() {
      const input = document.getElementById('uploadButton')
      if (input != null) {
        input.click()
      }
      this.progess = 0
      this.paginateConfig.page = 1
    },
    /** 选择excel并校验正确性 */
    onSelectExcel(value) {
      const _this = this
      this.isValidate = true
      const size = value.target.files[0].size
      if (size) {
        if (size >= 10 * 1024 * 1024) {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Customer.noFileBiggerThan'),
            type: 'error'
          })
          value.target.value = ''
          return
        }
      } else {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Customer.noFileBiggerThan'),
          type: 'error'
        })
        value.target.value = ''
        return
      }

      this.file = value.target.files[0]
      if (!this.file) {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Goods.fileTypeError'),
          type: 'error'
        })
        value.target.value = ''
        return
      }

      /** 判断文件类型 */
      const types = '.xls,.xlsx'.split(',')
      const name = this.file.name
      const type = name.substring(name.lastIndexOf('.'))
      if (types.indexOf(type) === -1) {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Goods.choiseTips'),
          type: 'error'
        })
        value.target.value = ''
        return
      }

      var formData = new FormData()
      formData.append('file', this.file)

      const config = {
        // 添加请求头
        headers: { 'Content-Type': 'multipart/form-data' },
        // 添加上传进度监听事件
        onUploadProgress: function(e) {
          // var completeProgress = (((e.loaded / e.total) * 100) | 0) + '%';
          _this.progress = (e.loaded / e.total) * 100
        }
      }

      this.showLoading = true
      this.handleValidateExcel({
        formData: formData,
        progess: config.onUploadProgress
      }).then(res => {
        if (res.success === true) {
          if (Object.keys(res).length > 1) {
            _this.paginateConfig.total = this.validateExcelData.invalidedMessages.length
            _this.showThirdStep = true
            _this.showItems = _this.getItemsByPage()
          }
          _this.showLoading = false
          value.target.value = ''
        } else {
          this.showThirdStep = false
          this.showLoading = false
          this.file = null
          value.target.value = ''
        }
      })
    },
    /** 确认上传 */
    onConfirmUpload() {
      this.isValidate = false
      const _this = this
      var formData = new FormData()
      formData.append('file', this.file)
      const config = {
        // 添加请求头
        headers: { 'Content-Type': 'multipart/form-data' },
        // 添加上传进度监听事件
        onUploadProgress: function(e) {
          _this.progress = (e.loaded / e.total) * 100
        }
      }

      this.showLoading = true

      this.handleImportExcel({
        formData: formData,
        progess: config.onUploadProgress
      }).then(res => {
        if (res.success === true) {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Customer.successImport', {
              '0': `${res.count}`
            }),
            type: 'success'
          })
          this.file = null
          _this.showThirdStep = false
          _this.showLoading = false
          _this.$router.back()
        } else {
          if (res) {
            if (res.error) {
              this.$store.commit('app/setNotification', {
                msg: res.error.message,
                type: 'error'
              })
            } else {
              this.$store.commit('app/setNotification', {
                msg: res.result.title,
                type: 'error'
              })
            }
          }
          _this.showThirdStep = false
          _this.showLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.download-button {
  text-decoration: none;
  color: white;
}
.required-mark {
  color: red;
  font-size: 20px;
}
.search-area {
  /* width: 100%; */
  background: #fff;
  border-radius: 12px;
  border-top: 10px solid #5cb85f;
}
.mt-20 {
  margin-top: 20px;
}
.card-title {
  font-weight: bold;
  font-size: 18px;
  color: #4caf50;
  letter-spacing: 0;
  margin: 26px 0 34px 30px;
}
.fix-margin{
  margin: 0 0 0 30px;
}
.fix-input-title{
  font-size: 14px;
  color: #212121;
  letter-spacing: 0;
  line-height: 16px;
  margin: 0 0 -12px 30px;
}
.require-mark::before {
  content: "*";
  color: red;
  font-size: 10px;
  font-weight: bold;
}
</style>

